import React, { Fragment, Component } from 'react'
// import FormModal from './gatedVideo';
// import Script from 'react-load-script';
// import { sendAnalyticsEvent, isScriptPresent } from '../helper/helper';
import './GlobalCTA.css';
export default class globalCTA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openGatedVideo: false,
      scriptVideoUrl: "https://players.brightcove.net/1815389247001/experience_5b0f79545eecca0010826d71/live.js",
      foundScript: false
    }
  }

//   componentDidMount() {
//     this.setState({ foundScript: isScriptPresent(this.state.scriptVideoUrl) });
//   }

//   sendAnalytics(name) {
//     sendAnalyticsEvent('CTA Link Clicked', name, this.props.dataMachineName, this.props.dataComponentName);
//   }

//   VideoCTA(gid, vid, name) {
//     sendAnalyticsEvent('CTA Link Clicked', name, this.props.dataMachineName, this.props.dataComponentName);
//     if ((gid == null) && vid) {
//       let parentElement = document.querySelector(`div[data-video-ids="${vid}"]`);
//       let iframe = parentElement.querySelector('iframe');
//       iframe.contentDocument.querySelector(".ee-components-play-button").click();      
//     }
//   }

//   openForm(formId, name) {
//     sendAnalyticsEvent('CTA Link Clicked', name, this.props.dataMachineName, this.props.dataComponentName);
//     /* istanbul ignore next */
//     if (formId) {
//       this.setState({
//         openGatedVideo: true
//       })
//     }
//   }

  resetForm() {
    this.setState({
      openGatedVideo: false
    })
  }

  render() {
    let ctaType = this.props.ctaType && this.props.ctaType ? this.props.ctaType : '',
      ctaUrl = this.props.ctaUrl && this.props.ctaUrl ? this.props.ctaUrl : '',
      ctaLabel = this.props.ctaLabel && this.props.ctaLabel ? this.props.ctaLabel : '',
      ctaFormID = this.props.ctaFormID && this.props.ctaFormID ? this.props.ctaFormID : '',
      ctaAssetFormID = this.props.ctaAssetFormID && this.props.ctaAssetFormID ? this.props.ctaAssetFormID : '',
      ctaVideoID = this.props.ctaVideoID && this.props.ctaVideoID ? this.props.ctaVideoID : '',
      ctaLinkTarget = this.props.ctaLinkTarget && this.props.ctaLinkTarget ? this.props.ctaLinkTarget : '',
      ctaAsset = this.props.ctaAsset && this.props.ctaAsset ? this.props.ctaAsset : '',
      campaignId = this.props.campaignId && this.props.campaignId ? this.props.campaignId : '',
      ctaTheme = this.props.ctaTheme && this.props.ctaTheme ? this.props.ctaTheme : '',
      screen = this.props.screen && this.props.screen ? this.props.screen : '',
      resolution,
      finalCTA, ctaStyle, ctaStyleInit;

      ctaStyleInit = ctaStyle = this.props.ctaStyle && this.props.ctaStyle ? this.props.ctaStyle : '';

    if (screen == "desktop") {
      resolution = 'desk'
    } else if (screen == "mobile") {
      resolution = 'mob'
    } else {
      resolution = ''
    }

    if (ctaTheme == 'custom') {
      ctaStyle = ctaStyle
    }
    else {
      if (ctaStyle == "primary_small") {
        ctaStyle = `${['prim']} ${['btn-sm']} ${resolution}`
      } else if (ctaStyle == "primary_large") {
        ctaStyle = `${['prim']} ${['btn-lg']} ${resolution}`
      } else if (ctaStyle == "primary_default") {
        ctaStyle = `${['prim']} ${resolution}`
      } else if (ctaStyle == "transparent_default") {
        ctaStyle = `${['clear_btn']} ${resolution}`
      } else if (ctaStyle == "none_link") {
        ctaStyle = `${['link']} ${resolution}`
      } else if (ctaStyle == "secondary_small") {
        ctaStyle = `${['sec']} ${['btn-sm']} ${resolution}`
      } else if (ctaStyle == "secondary_large") {
        ctaStyle = `${['sec']} ${['btn-lg']} ${resolution}`
      } else if (ctaStyle == "secondary_default") {
        ctaStyle = `${['sec']} ${resolution}`
      } else if (ctaStyle == "transparent_default_with_icon") {
        ctaStyle = `${['trasnparent_w_icon']} ${resolution}`
      } else if (ctaStyle === "link_cta_arrow_light"){
        ctaStyle = `${['trasnparent_w_icon']} ${['transparent_w_icon_light']} ${resolution}`
      } else {
        ctaStyle = `${['link']} ${resolution}`
      }
    }

    // rigth arrow icon svg
    let rightArrow = ctaStyleInit == "transparent_default_with_icon" ? (<span className='cta-icon-right-arrow'>
    <svg width="20" height="8" viewBox="0 0 20 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.8184 4.35355C20.0137 4.15829 20.0137 3.84171 19.8184 3.64645L16.6364 0.464466C16.4412 0.269204 16.1246 0.269204 15.9293 0.464466C15.734 0.659728 15.734 0.976311 15.9293 1.17157L18.7577 4L15.9293 6.82843C15.734 7.02369 15.734 7.34027 15.9293 7.53553C16.1246 7.7308 16.4412 7.7308 16.6364 7.53553L19.8184 4.35355ZM0 4.5L19.4648 4.5V3.5L0 3.5L0 4.5Z" fill="#FCFAF5"/>
    </svg>
  </span>) : null;
    rightArrow = ctaStyleInit === "link_cta_arrow_light" ? (<span className='cta-icon-right-arrow'>
      <svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.086 4.35355C20.2812 4.15829 20.2812 3.84171 20.086 3.64645L16.904 0.464466C16.7087 0.269204 16.3922 0.269204 16.1969 0.464466C16.0016 0.659728 16.0016 0.976311 16.1969 1.17157L19.0253 4L16.1969 6.82843C16.0016 7.02369 16.0016 7.34027 16.1969 7.53553C16.3922 7.7308 16.7087 7.7308 16.904 7.53553L20.086 4.35355ZM0.267578 4.5L19.7324 4.5V3.5L0.267578 3.5V4.5Z" fill="#F8F8F8"/>
      </svg>
    </span>) : null;
    if (ctaType === 'Link' || ctaType === 'link') {
      // onClick={() => this.sendAnalytics(ctaLabel)}
      finalCTA = <a id="g_cta" className={ctaStyle} href={ctaUrl}  target={ctaLinkTarget}>{ctaLabel}{rightArrow}</a>
    } else if (ctaType === 'Form' || ctaType === 'form') {
      // onClick={() => this.openForm({ ctaFormID }, ctaLabel)}
      finalCTA =
        <Fragment>
          <a id="g_cta" className={ctaStyle} href="javascript:void(0)">{ctaLabel}{rightArrow}</a>
          {/* <FormModal isGated={ctaFormID} openGatedVideo={this.state.openGatedVideo} resetForm={() => this.resetForm()} /> */}
        </Fragment>
    } else if (ctaType === 'Form with Video' || (ctaType === 'form_video' && campaignId !== true)) {
      // onClick={() => this.openForm({ ctaFormID }, ctaLabel)}
      finalCTA =
        <Fragment>
          <a id="g_cta" className={ctaStyle} href="javascript:void(0)">{ctaLabel}{rightArrow}</a>
          {/* <FormModal isVideo={ctaVideoID} isGated={ctaFormID} openGatedVideo={this.state.openGatedVideo} resetForm={() => this.resetForm()} /> */}
        </Fragment >
    } else if (ctaType === 'Video' || ctaType === 'video' || (ctaType === 'form_video' && campaignId === true)) {
      finalCTA =
        <Fragment>
          <a id="g_cta" className={ctaStyle} >{ctaLabel}{rightArrow}</a>
          <div style={{ display: 'none' }} id="vsdal-video" data-video-ids={ctaVideoID} data-experience="5b0f79545eecca0010826d71"></div>
          {/* {!this.state.foundScript ? <Script url={this.state.scriptVideoUrl} /> : ""} */}
        </Fragment>
    } else if (ctaType === 'form_asset' && campaignId !== true) {
      finalCTA =
        <Fragment>
        {/* onClick={() => this.openForm({ ctaAssetFormID }, ctaLabel)}  */}
          <a id="g_cta" className={ctaStyle} href="javascript:void(0)" >{ctaLabel}{rightArrow}</a>
          {/* <FormModal downloadLink={ctaAsset} isDownload={true} isGated={ctaAssetFormID} openGatedVideo={this.state.openGatedVideo} resetForm={() => this.resetForm()} /> */}
        </Fragment>
    } else if (ctaType === 'form_asset' && campaignId === true) {
      finalCTA = <a id="g_cta" className={ctaStyle} href={ctaAsset} target="_blank" type="application/pdf">{ctaLabel}{rightArrow}</a>
    } else if (ctaType === 'Action') {
      finalCTA = <a href="javascript:void(0)" id="g_cta" className={ctaStyle} onClick={() => this.props.ctaAction && this.props.ctaAction()} target={ctaLinkTarget}>{ctaLabel}{rightArrow}</a>
    }
    return (
      <Fragment> {finalCTA} </Fragment>
    )
  }
}
